module.exports = __webpack_public_path__ + "static/media/29ADMSPC34.5a3df1c0.jpg";